(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define([], function(){ return factory(root); });
  } else if (typeof module === 'object' && module.exports) {
    module.exports = factory(globalThis || (typeof self !== 'undefined' ? self : this));
  } else {
    root.SwishNbaLinePack = factory(root);
  }
}(typeof self !== 'undefined' ? self : this, function (GLOBAL) {
  'use strict';

  function normHex(x){ if(!x) return '#FFFFFF'; x=String(x).trim(); if(x[0] !== '#') x='#'+x; return x.toUpperCase(); }

  (function ensureNbaLines(){
    if (GLOBAL && GLOBAL.SwishNbaLines) return;
    const config = GLOBAL && GLOBAL.SwishCBConfig;
    const create = config && config.createBasketballProceduralLineAPI;
    if (typeof create !== 'function') {
      try { console.error('[SwishNbaLines] procedural basketball helper unavailable'); } catch (_) {}
      GLOBAL.SwishNbaLines = {
        ready: Promise.resolve(),
        design: { W: 15240, L: 28651.2 },
        draw: function(){}
      };
      return;
    }
    GLOBAL.SwishNbaLines = create({
      rulesetId: 'NBA',
      lengthM: 28.6512,
      widthM: 15.24
    });
  })();

  function draw2D(ctx, x0, y0, cw, ch, color, opts) {
    if (GLOBAL.SwishNbaLines && typeof GLOBAL.SwishNbaLines.draw === 'function') {
      GLOBAL.SwishNbaLines.draw(ctx, x0, y0, cw, ch, normHex(color), Object.assign({ only: null, hideCenter: false }, opts || {}));
    }
  }

  function defaults() { return { length: 28.6512, width: 15.24 }; }

  const linesApi = GLOBAL.SwishNbaLines || {};

  return {
    id: 'nba.linepack',
    draw2D: draw2D,
    draw: draw2D,
    design: linesApi.design || { W: 15240, L: 28651.2 },
    ready: linesApi.ready || Promise.resolve(),
    defaults: defaults
  };
}));
